/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink, useHistory } from "react-router-dom";
import cx from "classnames";
// Amplify components
import { Auth } from "aws-amplify";

// @material-ui/core components
import { ArcadeEmbed } from "views/Pages/HomePage";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.js";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PhotoIcon from "@material-ui/icons/Photo";
import SchoolIcon from "@material-ui/icons/School";
import Fingerprint from "@material-ui/icons/Fingerprint";
import PersonAdd from "@material-ui/icons/PersonAdd";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import BrushIcon from "@material-ui/icons/Brush";
import ListAltIcon from "@material-ui/icons/ListAlt";
import CollectionsBookmarkIcon from "@material-ui/icons/CollectionsBookmark";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.js";
import { getUserRoleAPI } from "views/APIs/APIUtility";
import avatar from "assets/img/faces/generic-user-icon-19.jpg";
import {
  Apartment,
  Assistant,
  Folder,
  HelpOutline,
  Home,
  ListAlt,
  Notes,
  PeopleAlt,
} from "@material-ui/icons";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  ListItemSecondaryAction,
  Tooltip,
  Typography,
} from "@material-ui/core";

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  sidebarWrapper = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebarWrapper.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  render() {
    const { className, user, headerLinks, links } = this.props;
    return (
      <div className={className} ref={this.sidebarWrapper}>
        {user}
        {headerLinks}
        {links}
      </div>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    const { location, history } = this.props;
    this.state = {
      openAvatar: false,
      miniActive: true,
      ...this.getCollapseStates(props.routes),
    };
  }
  mainPanel = React.createRef();

  state = {
    openHelpModal: false,
  };

  handleOpenHelp = () => {
    this.setState({ openHelpModal: true });
  };
  handleCloseHelp = () => {
    this.setState({ openHelpModal: false });
  };

  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };

  getCurrentRole = () => {
    getUserRoleAPI().then((response) => {
      this.setState({ role: response.role });
    });
  };

  componentDidMount() {
    this.getCurrentUser();
    this.getCurrentRole();
  }

  getCurrentUser = () => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.setState({
          email: user.attributes.email,
          name: user.attributes.given_name + " " + user.attributes.family_name,
        });
        this.setState({
          userType: user.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].find(Boolean),
        });
      })
      .catch((err) => console.log(err));
  };

  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /create/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }

  // verifies if routeName is the one active (in browser input)
  activeRoute = (routeName) => {
    return window.location.href.indexOf(routeName) > -1 ? "active" : "";
  };

  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }

  logOutUser = async () => {
    await Auth.signOut()
      .then((user) => {
        this.setState({ email: undefined });
        localStorage.clear();
        window.location.href = "/auth/login-page";
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    const { classes, color, rtlActive } = this.props;
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (!prop.roles.includes(this.state.role)) {
        return null;
      }
      if (
        prop.hasOwnProperty("userTypes") &&
        !prop["userTypes"].includes(this.state.userType)
      ) {
        return null;
      }
      if (prop.hidden) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        const navLinkClasses =
          classes.itemLink +
          " " +
          cx({
            [" " + classes.collapseActive]: this.getCollapseInitialState(
              prop.views
            ),
          });
        const itemText =
          classes.itemText +
          " " +
          cx({
            [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,
            [classes.itemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
            [classes.itemTextRTL]: rtlActive,
          });
        const collapseItemText =
          classes.collapseItemText +
          " " +
          cx({
            [classes.collapseItemTextMini]:
              this.props.miniActive && this.state.miniActive,
            [classes.collapseItemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
            [classes.collapseItemTextRTL]: rtlActive,
          });
        const itemIcon =
          classes.itemIcon +
          " " +
          cx({
            [classes.itemIconRTL]: rtlActive,
          });
        const caret =
          classes.caret +
          " " +
          cx({
            [classes.caretRTL]: rtlActive,
          });
        const collapseItemMini =
          classes.collapseItemMini +
          " " +
          cx({
            [classes.collapseItemMiniRTL]: rtlActive,
          });
        return (
          <ListItem
            key={key}
            className={cx(
              { [classes.item]: prop.icon !== undefined },
              { [classes.collapseItem]: prop.icon === undefined }
            )}
          >
            <NavLink
              to={"#"}
              className={navLinkClasses}
              onClick={(e) => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                typeof prop.icon === "string" ? (
                  <Icon className={itemIcon}>{prop.icon}</Icon>
                ) : (
                  <prop.icon className={itemIcon} />
                )
              ) : (
                <span className={collapseItemMini}>
                  {rtlActive ? prop.rtlMini : prop.mini}
                </span>
              )}
              <ListItemText
                primary={rtlActive ? prop.rtlName : prop.name}
                secondary={
                  <b
                    className={
                      caret +
                      " " +
                      (this.state[prop.state] ? classes.caretActive : "")
                    }
                  />
                }
                disableTypography={true}
                className={cx(
                  { [itemText]: prop.icon !== undefined },
                  { [collapseItemText]: prop.icon === undefined }
                )}
              />
            </NavLink>
            <Collapse in={this.state[prop.state]} unmountOnExit>
              <List className={classes.list + " " + classes.collapseList}>
                {this.createLinks(prop.views)}
              </List>
            </Collapse>
          </ListItem>
        );
      }
      const innerNavLinkClasses =
        classes.collapseItemLink +
        " " +
        cx({
          [" " + classes[color]]: this.activeRoute(prop.path),
        });
      const collapseItemMini =
        classes.collapseItemMini +
        " " +
        cx({
          [classes.collapseItemMiniRTL]: rtlActive,
        });
      const navLinkClasses =
        classes.itemLink +
        // Uncomment below code for showing a different color for active sidebar item
        " " +
        cx({
          [" " + classes[color]]: this.activeRoute(prop.path),
        });
      const itemText =
        classes.itemText +
        " " +
        cx({
          [classes.itemTextMini]:
            this.props.miniActive && this.state.miniActive,
          [classes.itemTextMiniRTL]:
            rtlActive && this.props.miniActive && this.state.miniActive,
          [classes.itemTextRTL]: rtlActive,
        });
      const collapseItemText =
        classes.collapseItemText +
        " " +
        cx({
          [classes.collapseItemTextMini]:
            this.props.miniActive && this.state.miniActive,
          [classes.collapseItemTextMiniRTL]:
            rtlActive && this.props.miniActive && this.state.miniActive,
          [classes.collapseItemTextRTL]: rtlActive,
        });
      const itemIcon =
        classes.itemIcon +
        " " +
        cx({
          [classes.itemIconRTL]: rtlActive,
        });
      return (
        <ListItem
          key={key}
          className={cx(
            { [classes.item]: prop.icon !== undefined },
            { [classes.collapseItem]: prop.icon === undefined }
          )}
        >
          <NavLink
            to={prop.layout + prop.path}
            className={cx(
              { [navLinkClasses]: prop.icon !== undefined },
              { [innerNavLinkClasses]: prop.icon === undefined }
            )}
            activeClassName={classes[color]}
          >
            {prop.icon !== undefined ? (
              typeof prop.icon === "string" ? (
                <Icon className={itemIcon}>{prop.icon}</Icon>
              ) : (
                <prop.icon className={itemIcon} />
              )
            ) : (
              <span className={collapseItemMini}>
                {rtlActive ? prop.rtlMini : prop.mini}
              </span>
            )}
            <ListItemText
              primary={rtlActive ? prop.rtlName : prop.name}
              disableTypography={true}
              className={cx(
                { [itemText]: prop.icon !== undefined },
                { [collapseItemText]: prop.icon === undefined }
              )}
            />
          </NavLink>
        </ListItem>
      );
    });
  };

  // this is for the user links
  render() {
    const {
      classes,
      logo,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive,
    } = this.props;

    const itemText =
      classes.itemText +
      " " +
      cx({
        [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
        [classes.itemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.itemTextRTL]: rtlActive,
      });
    const collapseItemText =
      classes.collapseItemText +
      " " +
      cx({
        [classes.collapseItemTextMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextRTL]: rtlActive,
      });
    const userWrapperClass =
      classes.user +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white",
      });
    const caret =
      classes.caret +
      " " +
      cx({
        [classes.caretRTL]: rtlActive,
      });
    const collapseItemMini =
      classes.collapseItemMini +
      " " +
      cx({
        [classes.collapseItemMiniRTL]: rtlActive,
      });
    const photo =
      classes.photo +
      " " +
      cx({
        [classes.photoRTL]: rtlActive,
      });
    // For unauthenticated users, show login/register at top
    var userTop = null;
    if (!this.state.email) {
      userTop = (
        <div className={userWrapperClass}>
          <List className={classes.list}>
            <ListItem className={classes.item}>
              <NavLink
                to="/auth/login-page"
                className={classes.itemLink + " " + classes.userCollapseLinks}
                activeClassName={
                  classes[this.props.color] ? classes.white : classes.blue
                }
              >
                <span className={collapseItemMini}>
                  <Fingerprint className={classes.listItemIcon} />
                </span>
                <ListItemText
                  primary="Login"
                  disableTypography={true}
                  className={collapseItemText}
                />
              </NavLink>
            </ListItem>
          </List>

          <List className={classes.list}>
            <ListItem className={classes.item}>
              <NavLink
                to="/auth/register-page"
                className={classes.itemLink + " " + classes.userCollapseLinks}
                activeClassName={
                  classes[this.props.color] ? classes.white : classes.blue
                }
              >
                <span className={collapseItemMini}>
                  <PersonAdd className={classes.listItemIcon} />
                </span>
                <ListItemText
                  primary="Register"
                  disableTypography={true}
                  className={collapseItemText}
                />
              </NavLink>
            </ListItem>
          </List>
        </div>
      );
    }

    // For authenticated users, prepare profile block to show at bottom
    var bottomUser = null;
    if (this.state.email) {
      const isMiniActive = this.props.miniActive && this.state.miniActive;
      bottomUser = (
        <div
          style={{
            position: "absolute",
            bottom: 10,
            width: "100%",
          }}
        >
          <div
            className={userWrapperClass}
            style={{
              paddingLeft: "15px",
              paddingRight: "15px",
            }}
          >
            <List className={classes.list} style={{ marginTop: 0 }}>
              <ListItem className={classes.item + " " + classes.userItem}>
                <NavLink
                  to="/create/user-page"
                  className={
                    classes.itemLink + " " + classes.userCollapseButton
                  }
                  activeClassName={
                    classes[this.props.color] ? classes.white : classes.blue
                  }
                  onClick={() => this.openCollapse("openAvatar")}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    paddingLeft: isMiniActive ? 0 : "8px",
                    paddingRight: isMiniActive ? 0 : undefined,
                    justifyContent: isMiniActive ? "center" : "flex-start",
                    margin: isMiniActive ? "10px 0 0" : undefined,
                  }}
                >
                  <div
                    className={photo}
                    style={{
                      marginLeft: 0,
                      marginRight: isMiniActive ? 0 : "11px",
                    }}
                  >
                    <img src={avatar} className={classes.avatarImg} alt="..." />
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: isMiniActive ? "none" : "block",
                    }}
                  >
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {this.state.name}
                    </div>
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "12px",
                        opacity: 0.8,
                      }}
                    >
                      {this.state.email}
                    </div>
                  </div>
                </NavLink>
              </ListItem>
            </List>
            <div
              style={{
                display: "flex",
                justifyContent: isMiniActive ? "center" : "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex" }}>
                {!isMiniActive && (
                  <Tooltip title="Terms and Conditions" placement="top">
                    <IconButton
                      onClick={() =>
                        window.open(
                          "https://www.quantuniversity.com/privacy.html",
                          "_blank"
                        )
                      }
                      style={{ color: "white" }}
                      size="small"
                    >
                      <Notes fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Help" placement="top">
                  <IconButton
                    onClick={this.handleOpenHelp}
                    style={{ color: "white" }}
                    size="small"
                  >
                    <HelpOutline fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>

              <Tooltip title="Log Out" placement="top">
                <IconButton
                  onClick={() => this.logOutUser()}
                  style={{ color: "white" }}
                  size="small"
                >
                  <ExitToAppIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      );
    }

    var links = (
      <div>
        <List className={classes.list}>{this.createLinks(routes)}</List>
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <NavLink
              to="/create/landing-page"
              className={classes.itemLink + " " + classes.userCollapseLinks}
              activeClassName={
                classes[this.props.color] ? classes.white : classes.blue
              }
            >
              <span className={collapseItemMini}>
                <Assistant />
              </span>
              <ListItemText
                primary="Solution Accelerator"
                disableTypography={true}
                className={collapseItemText}
              />
            </NavLink>
          </ListItem>
        </List>
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <NavLink
              to="/create/project-design"
              className={classes.itemLink + " " + classes.userCollapseLinks}
              activeClassName={
                classes[this.props.color] ? classes.white : classes.blue
              }
            >
              <span className={collapseItemMini}>
                <CollectionsBookmarkIcon />
              </span>
              <ListItemText
                primary="My Projects"
                disableTypography={true}
                className={collapseItemText}
              />
            </NavLink>
          </ListItem>
        </List>
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <NavLink
              to="/create/qcreate-studio"
              className={classes.itemLink + " " + classes.userCollapseLinks}
              activeClassName={
                classes[this.props.color] ? classes.white : classes.blue
              }
            >
              <span className={collapseItemMini}>
                <FormatPaintIcon />
              </span>
              <ListItemText
                primary="QCreate Studio"
                disableTypography={true}
                className={collapseItemText}
              />
            </NavLink>
          </ListItem>
        </List>

        <List className={classes.list}>
          <ListItem className={classes.item}>
            <NavLink
              to="/create/qu-api-vault"
              className={classes.itemLink + " " + classes.userCollapseLinks}
              activeClassName={
                classes[this.props.color] ? classes.white : classes.blue
              }
            >
              <span className={collapseItemMini}>
                <VpnKeyIcon />
              </span>
              <ListItemText
                primary="QuAPIVault"
                disableTypography={true}
                className={collapseItemText}
              />
            </NavLink>
          </ListItem>
        </List>

        {/* <List className={classes.list}>
          <ListItem className={classes.item}>
            <NavLink
              to="/create/templates"
              className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              <span className={collapseItemMini}>
                <ListAltIcon />
              </span>
              <ListItemText
                primary="QuModelStudio"
                disableTypography={true}
                className={collapseItemText}
              />
            </NavLink>
          </ListItem>
        </List>
        
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <a
              href="https://quskillbridge.qusandbox.com/"
              target="_blank"
              className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              <span className={collapseItemMini}>
                <MenuBookIcon />
              </span>
              <ListItemText
                primary="QuSkillBridge"
                disableTypography={true}
                className={collapseItemText}
              />
            </a>
          </ListItem>
        </List> */}
        {/* <List className={classes.list}>
          <ListItem className={classes.item}>
            <a
              // href="https://test2-mr.qusandbox.com/#!/signin?redirect=%2Fpipelines"
              href="https://modelrisk.qusandbox.com/"
              target="_blank"
              className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              <span className={collapseItemMini}>
                <PhotoIcon />
              </span>
              <ListItemText
                primary="QuModelStudio"
                disableTypography={true}
                className={collapseItemText}
              />
            </a>
          </ListItem>
        </List> */}
        {/* <Divider
          style={{
            margin: "20px",
            backgroundColor: "lightgrey",
          }}
        />
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <a
              href="https://www.quantuniversity.com/"
              target="_blank"
              className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              <span className={collapseItemMini}>
                <Apartment />
              </span>
              <ListItemText
                primary="QuantUniversity"
                disableTypography={true}
                className={collapseItemText}
              />
            </a>
          </ListItem>
        </List>
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <a
              href="https://academy.qusandbox.com/"
              target="_blank"
              className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              <span className={collapseItemMini}>
                <SchoolIcon />
              </span>
              <ListItemText
                primary="QuAcademy"
                disableTypography={true}
                className={collapseItemText}
              />
            </a>
          </ListItem>
        </List>
*/}
        {this.state.role === "super_admin" && (
          <>
            <Divider
              style={{
                margin: "20px",
                backgroundColor: "#61676d",
              }}
            />
            <Typography
              variant="body1"
              style={{
                margin: "20px",
                color: "#ffffff",
                display:
                  this.props.miniActive && this.state.miniActive
                    ? "none"
                    : "block",
              }}
            >
              Profile Administration
            </Typography>
            <List className={classes.list}>
              <ListItem className={classes.item}>
                <NavLink
                  to="/create/codes"
                  className={classes.itemLink + " " + classes.userCollapseLinks}
                  activeClassName={
                    classes[this.props.color] ? classes.white : classes.blue
                  }
                >
                  <span className={collapseItemMini}>
                    <CollectionsBookmarkIcon />
                  </span>
                  <ListItemText
                    primary="Toolbox Access Codes"
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
            </List>
            <List className={classes.list}>
              <ListItem className={classes.item}>
                <NavLink
                  to="/create/prompt-hub"
                  className={classes.itemLink + " " + classes.userCollapseLinks}
                  activeClassName={
                    classes[this.props.color] ? classes.white : classes.blue
                  }
                >
                  <span className={collapseItemMini}>
                    <ListAlt />
                  </span>
                  <ListItemText
                    primary="Prompt Hub"
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
            </List>
            <Divider
              style={{
                margin: "20px",
                backgroundColor: "#61676d",
              }}
            />
          </>
        )}

        {bottomUser}
      </div>
    );

    const logoNormal =
      classes.logoNormal +
      " " +
      cx({
        [classes.logoNormalSidebarMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.logoNormalSidebarMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.logoNormalRTL]: rtlActive,
      });
    const logoMini =
      classes.logoMini +
      " " +
      cx({
        [classes.logoMiniRTL]: rtlActive,
      });
    const logoClasses =
      classes.logo +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white",
      });
    var brand = (
      <div className={logoClasses}>
        <a href="/create/landing-page" className={logoNormal}>
          <img src={logo} alt="logo" className={classes.img} />
        </a>
      </div>
    );
    const drawerPaper =
      classes.drawerPaper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: rtlActive,
      });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1,
      });
    return (
      <div ref={this.mainPanel}>
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={rtlActive ? "left" : "right"}
            open={this.props.open}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={userTop}
              // headerLinks={<AdminNavbarLinks rtlActive={rtlActive} />}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
        {/* Help Modal */}
        <Dialog
          open={this.state.openHelpModal}
          onClose={this.handleCloseHelp}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Interactive demo</DialogTitle>
          <DialogContent>
            <ArcadeEmbed />
          </DialogContent>
        </Dialog>
        <Hidden smDown implementation="css">
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? "right" : "left"}
            variant="permanent"
            open
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={userTop}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue",
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
};

SidebarWrapper.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  headerLinks: PropTypes.object,
  links: PropTypes.object,
};

export default withStyles(sidebarStyle)(Sidebar);
